export default {
  container: {
    boxShadow: 'inset 0 0 2px #d3d3d3',
    border: 'solid .05px rgba(0, 0, 0, .065)',
    backgroundColor: 'white',
    marginTop: '15px',
    padding: '10px',
    boxSizing: 'border-box'
  },
  labelContainerfull: {
    display: 'flex',
    flexDirection: 'column'
  },
  labelContainersectionWrap: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  termsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  term: {
    position: 'relative',
    backgroundColor: 'rgb(226, 226, 226)',
    marginRight: '35px',
    fontWeight: '600',
    padding: '8px',
    borderRadius: '3px 0px 0px 3px'
  },
  positionContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  positionBtn: {
    marginRight: '18px',
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    alignItems: 'center'
  },
  warning: {
    color: 'rgb(230, 83, 83)',
    fontWeight: '700'
  },
  disclaimer: {
    color: '#d05755',
    margin: '5px 2px',
    fontSize: '13px'
  },
  icon: {
    height:'15px',
    width: '15px',
    cursor: 'pointer',
    marginRight: '3px'
  },
  termRemove: {
    position: 'absolute',
    backgroundColor: 'rgb(226, 226, 226)',
    height: '100%',
    top: '0',
    right: '-20px',
    display: 'flex',
    flexDirection: 'row',
    padding: '3px 7px',
    borderRadius: '0px 3px 3px 0px',
    alignItems: 'center',
    justifyContent:'center',
    cursor: 'pointer'
  },
  textInput: {
    height: '30px',
    border: '1px solid #ccc',
    borderRadius: '1px',
    padding: '0 0 0 4px',
    minWidth: '100%'
  },
  label: {
    marginBottom: '10px',
    marginRight: '10px'
  },
  labelsectionWrap: {
    marginBottom: '50px'
  }
}
